module.exports = __webpack_public_path__ + "974b8f5a4eef83e876ca9a3334ba08a4.MP3";